<div class="login-container">
	<mat-card class="mat-card-no-padding" [ngClass]="{ 'background-blue': showResetEmailComplete }">
		<div class="row-center banner"></div>

		<div class="login-card-content-wide">
			@if (!showResetEmailComplete) {
				<div>
					<h2 class="row-center title-margin title-font-size" i18n="@@resetPassword-resetPasswordTitle">
						Reset Password
					</h2>
					<div class="flex-row">
						<mat-form-field subscriptSizing="dynamic" class="input-width-right" appearance="outline">
							<mat-label i18n="@@resetPassword-password">Password</mat-label>
							<input
								[type]="hide ? 'password' : 'text'"
								matInput
								[formControl]="passwordFormControl"
								required
								data-automation-id="password-input"
							/>
							<button mat-icon-button matSuffix (click)="hide = !hide" data-automation-id="reset-pwd-password-button">
								<mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
							</button>
							@if (passwordFormControl.hasError('password') && !passwordFormControl.hasError('required')) {
								<mat-error i18n="@@resetPassword-pleaseEnter" data-automation-id="password-error">
									Please enter a password
								</mat-error>
							}
							@if (passwordFormControl.hasError('required')) {
								<mat-error i18n="@@resetPassword-passwordRequired" data-automation-id="password-error">
									Password is <strong>required</strong>
								</mat-error>
							}
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="input-width-left" appearance="outline">
							<mat-label i18n="@@resetPassword-confirmPasswordLabel">Confirm Password</mat-label>
							<input
								[type]="hide ? 'password' : 'text'"
								matInput
								[formControl]="confirmPasswordFormControl"
								required
								data-automation-id="confirm-password-input"
							/>
							<button
								mat-icon-button
								matSuffix
								(click)="hide = !hide"
								data-automation-id="reset-pwd-confirm-password-button"
							>
								<mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
							</button>
							@if (
								confirmPasswordFormControl.hasError('password') && !confirmPasswordFormControl.hasError('required')
							) {
								<mat-error data-automation-id="confirm-password-error" i18n="@@resetPassword-ErrorMessage">
									Please confirm your password
								</mat-error>
							}
							@if (passwordFormControl.hasError('required')) {
								<mat-error i18n="@@resetPassword-confirmPasswordRequired" data-automation-id="confirm-password-error">
									Password is <strong>required</strong>
								</mat-error>
							}
						</mat-form-field>
					</div>
					<app-password-validation
						#passwordValidation
						[passwordFormControl]="passwordFormControl"
						[confirmPasswordFormControl]="confirmPasswordFormControl"
					>
					</app-password-validation>
					<button
						mat-button
						class="primary-button"
						data-automation-id="reset-pwd-submit-password-reset-button"
						style="margin-top: 40px"
						[disabled]="!passwordValidation.passwordIsValid()"
						(click)="submitPasswordReset()"
						i18n="@@resetPassword-confirmButton"
					>
						Confirm
					</button>
				</div>
			} @else {
				<div>
					<mat-icon class="success-checkmark">check</mat-icon>
					<h2 class="row-center title" i18n="@@resetPassword-completeTitle">Reset Password Complete</h2>
					<p class="font-14" i18n="@@resetPassword-completeSubtitle">You have successfully reset your password.</p>
					<button
						mat-button
						data-automation-id="reset-pwd-sign-in-button"
						class="primary-button button-small"
						(click)="onSignInClicked()"
						i18n="@@resetPassword-signin"
					>
						Sign In
					</button>
				</div>
			}
		</div>

		<div class="column-flex-end">
			<div class="row-flex-center">
				<mat-divider></mat-divider>
				<div class="tos-and-privacy-policy">
					<app-tos-and-privacy-policy></app-tos-and-privacy-policy>
				</div>
			</div>
		</div>
	</mat-card>
</div>
